import { AlertTriangle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../App';

/**
 * Notification banners for admin messages and account restrictions
 */
export const NotificationBanners = ({ 
  user, 
  setUser, 
  needsVerification, 
  visibleNotifications, 
  dismissNotification 
}) => {
  const handleRequestVerification = async () => {
    if (window.confirm('Have you verified your email but still cannot access chat features? Click OK to request manual verification from admin.')) {
      try {
        const token = localStorage.getItem('token');
        await axios.post(`${API}/auth/request-manual-verification`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('Request submitted! Your account is now under review. Admin will grant access soon.');
      } catch (error) {
        if (error.response?.status === 409) {
          toast.info('Your request is already under review. Please wait for admin approval.');
        } else {
          toast.error(error.response?.data?.detail || 'Failed to submit request');
        }
      }
    }
  };

  const dismissBanner = () => {
    localStorage.setItem(`banner_dismissed_${user.id}`, 'true');
    setUser({...user});
  };

  return (
    <>
      {/* Account Restriction Banner */}
      {user && needsVerification && !localStorage.getItem(`banner_dismissed_${user.id}`) && (
        <div className="bg-yellow-400 text-gray-900 px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1">
            <AlertTriangle className="w-5 h-5" />
            <span className="font-medium">
              ⚠️ Your account is restricted (banned from {user.ban_count || 3}+ rooms). Contact admin for verification.
            </span>
            <span className="text-sm">Bans: {user.ban_count || 0}</span>
            <span className="mx-2 text-gray-700">|</span>
            <button 
              onClick={handleRequestVerification}
              className="ml-2 text-blue-700 hover:text-blue-900 text-sm underline font-bold"
            >
              Contact Admin
            </button>
          </div>
          <button
            onClick={dismissBanner}
            className="ml-4 text-gray-900 hover:text-gray-700 font-bold text-xl"
            title="Dismiss banner"
          >
            ×
          </button>
        </div>
      )}
      
      {/* Admin Notifications */}
      {visibleNotifications.length > 0 && (
        <div className="space-y-2">
          {visibleNotifications.map((notification) => (
            <div
              key={notification.id}
              className="flex items-center justify-between px-4 py-3 text-white text-sm shadow-md"
              style={{ backgroundColor: notification.color || '#3B82F6' }}
            >
              <div className="flex-1">
                <span className="font-bold mr-2">{notification.title}:</span>
                <span>{notification.message}</span>
              </div>
              <button
                onClick={() => dismissNotification(notification.id)}
                className="ml-4 hover:opacity-75 font-bold text-xl"
                title="Dismiss notification"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default NotificationBanners;
